/**************************************************
 * Nombre:       Dialogo_Pedido
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Pedido from "../Formularios/Formulario_Pedido";
import {obtenerGuia} from "../../Modulo_EnviosT1/Funciones/obtenerGuia";
import dayjs from "dayjs";
import {ESTADOSPEDIDOS} from "../../Constantes";
import {enviarNotificacion} from "../../CodNegocio/Notificaciones/enviarNotificacion";
import {limpiarCelular} from "../../Modulo_formularios/Funciones/limpiarCelular";

const Dialogo_Pedido = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })

    const generarGuia = async () => {

        let pedido = await obtenerEntidad(datos)
        iniciarCarga('Creando Guia')
        let dox = await obtenerGuia({pedido: pedido})

        if (dox.status && dox.status === 200 && dox.data[0] && dox.data[0].detail && dox.data[0].detail.guide_link) {
            let detalles = dox.data[0].detail
            props.setValue('linkGuia', detalles.guide_link)
            props.setValue('fechaCreacionGuia', dayjs(detalles.creation_date).valueOf())
            props.setValue(`estado`, ESTADOSPEDIDOS[1].nombre)
            props.setValue('empresaEnvio', detalles.carrier)
            props.setValue('numGuia', detalles.tracking_number)

            await enviarMensaje({num_orden: dox.num_orden, paqueteria: dox.paqueteria})
            await subirDatos()

        } else {
            let mensajeCrudo = limpiarYParsearJSON(dox.data[0].error.message)
            console.log(mensajeCrudo)
            terminar({
                aviso: `No se genero guia Error: ${mensajeCrudo.datos.message}, Verifica el estado de la guia en la plataforma T1`,
                variante: 'error'
            })

        }


    }

    const enviarMensaje = async ({num_orden, paqueteria}) => {

        let numero = props.getValues('celular')
        let mensaje =
            `Generacion Mezcal: tu pedido esta siendo preparado para despacho, \\nNum Guia: ${num_orden} \\nPaqueteria: ${paqueteria}\\n`


        await enviarNotificacion({numero: limpiarCelular(numero), mensaje: mensaje})

    }

    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Subiendo Datos')


        let dox = await guardarDoc('pedidos', entidad)
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }

    }

    const borrar = async () => {
        await borrarDoc('pedidos', datos.id)
        terminar({aviso: 'Pedido borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Pedido props={props} click={generarGuia}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Pedido


function limpiarYParsearJSON(textoCrudo) {
    try {
        // 1. Quitamos el prefijo "400 - " (si existe) y limpiamos espacios o comillas exteriores
        let textoLimpio = textoCrudo.replace(/^400\s*-\s*/, '').trim();

        // Si el texto empieza y termina con comillas físicas escapadas, las removemos
        if (textoLimpio.startsWith('"') && textoLimpio.endsWith('"')) {
            textoLimpio = textoLimpio.slice(1, -1);
        }

        // 2. Primer parseo: Quita el primer nivel de escapado (las diagonales extra)
        const primerPaso = JSON.parse(`"${textoLimpio}"`);

        // 3. Segundo parseo: Convierte la cadena limpia en el objeto final de JavaScript
        const objetoFinal = JSON.parse(primerPaso);

        return {
            exito: true,
            datos: objetoFinal
        };

    } catch (error) {
        console.error("Error al procesar el texto:", error.message);
        return {
            exito: false,
            error: "No se pudo parsear el texto. Verifica el formato."
        };
    }
}